import './Wppbtn.scss';
import Image from '../Image/Image';
import WppLogoWebP from '../../assets/images/whatsapp-logo.webp';

const Wppbtn = () => {
  return (
    <div className={`wpp-btn-fixed`}>
      <a href="https://wa.me/message/ALLSQ5C5J6CMN1" target="_blank"  rel="noreferrer noopener"><Image webpDesktopSrc={WppLogoWebP} webpMobileSrc={WppLogoWebP} width={'70px'} loading={'lazy'} alt={'WhatsApp Logo'} /></a>
    </div>
  );
};

export default Wppbtn;
